import sanitizeHtml from 'sanitize-html';


/**
 * @param input {any} Object to check for "emptiness"
 * @return {boolean} True if empty; false if not
 */
export const isEmpty = input => {

    return input === undefined
        || input === null
        || input === '';
};


export const contains = (input, contained) => {

    if (!input || typeof input !== 'string') {

        return false;
    }

    if (!contained) {

        return false;
    }

    return input.toLowerCase()
        .includes(contained.toLowerCase());
};


/**
 * Splits text by double line breaks (any kind)
 *
 * @param text {undefined|null|string}
 * @return {array|string[]}
 */
export const splitByParagraphs = text => {

    const processedText = (text || '').trimStart();

    return processedText.split(/\r\n{2,}|\r{2,}|\n{2,}/g)
        .map(splitText => splitText.trim())
        .filter(splitText => splitText.length > 0);
};


/**
 * Removes any tag such as XML etc.
 *
 * @param text {string}
 * @return {string}
 */
const removeTags = text => {

    const sanitized = sanitizeHtml(text || '', {
        // removing all elements
        exclusiveFilter: () => true
    });

    // all text is escaped atm but we want the real
    const tmpNode = document.createElement('div');
    tmpNode.innerHTML = sanitized;

    return tmpNode.innerText;
};


/**
 * @param text {string} Input text to be filterd
 */
export const filterText = text => {

    let processedText = (text || '').trimStart();

    processedText = removeTags(processedText);

    return processedText;
};

